import constants from 'core/types'
import { takeEvery, put, select, call } from 'redux-saga/effects'
import { Token, CurrencyAmount, TradeType } from '@uniswap/sdk-core'
import { Pair, Route, Trade } from '@uniswap/v2-sdk'
import uniswapV2poolABI from '@uniswap/v2-core/build/UniswapV2Pair.json'
import { ethers } from "ethers"
import { 
  getTokens,
  getInputOutputTokenAmounts,
  getInputOutputTokenAmountsUSD
} from 'core/libs/lib-token-helpers'

export function* updateTradeRoute(action) {
  const { routeUpdated } = action

  yield put({
    type: constants.SET_UPDATED_TRADE_ROUTE,
    payload: { routeUpdated }
  })
}

export function* selectCurrency(action) {
  const { selectedCurrencies } = action
  const { currency0, currency1 } = selectedCurrencies
 
  yield put({
    type: constants.SET_SELECTED_CURRENCIES,
    payload: {
      currency0,
      currency1
    }
  })
}

export function* enterInputAmount(actions) {
  const { inputAmount } = actions
  const { currency0, currency1, routeUpdated } = yield select(state => state.currency)
  const { chainId, web3Provider } = yield select(state => state.provider)

  try {
    const { token0Retrieved, token1Retrieved } = getTokens(currency0, currency1)
    const token0 = new Token(chainId, token0Retrieved.tokenAddress, parseInt(token0Retrieved.tokenDecimals, 10))
    const token1 = new Token(chainId, token1Retrieved.tokenAddress, parseInt(token1Retrieved.tokenDecimals, 10))
    const pairAddress = Pair.getAddress(token0, token1)
    const pairContract = new ethers.Contract(pairAddress, uniswapV2poolABI.abi, web3Provider)
    const reserves = yield pairContract["getReserves"]()
    const [reserve0, reserve1] = reserves
    // const tokens = [token0, token1]
    // const [tokenA, tokenB] = tokens[0].sortsBefore(tokens[1]) ? tokens : [tokens[1], tokens[0]]

    const pair = new Pair(
      CurrencyAmount.fromRawAmount(token0, Number(reserve0)),
      CurrencyAmount.fromRawAmount(token1, Number(reserve1))
    )

    if(inputAmount > 0) {
      let route, trade

      if(routeUpdated) {
        route = new Route([pair], token0, token1)
        trade = new Trade(route, CurrencyAmount.fromRawAmount(token0, Number(inputAmount)), TradeType.EXACT_INPUT)
      } else {
        route = new Route([pair], token1, token0)
        trade = new Trade(route, CurrencyAmount.fromRawAmount(token1, Number(inputAmount)), TradeType.EXACT_INPUT)
      }

      const { input, output } = yield call(getInputOutputTokenAmounts, trade, token0, token1)
      const { inputUSD, outputUSD } = yield call(getInputOutputTokenAmountsUSD, currency0, currency1, input, output)

      yield put({
        type: constants.SET_CURRENCY_AMOUNTS,
        payload: {
          token0: token0,
          token1: token1, 
          token0Amount: input,
          token1Amount: output,
          token0AmountUSD: inputUSD,
          token1AmountUSD: outputUSD
        }
      })
    } else {
      yield put({
        type: constants.CLEAR_CURRENCY_AMOUNTS
      })
    }
  } catch(e) {
    console.log('---- EnterInputAmount error: -----', e)
  }
}

export function* watchCurrencyActions() {
  yield takeEvery(constants.UPDATE_TRADE_ROUTE, updateTradeRoute)
  yield takeEvery(constants.SELECT_CURRENCY, selectCurrency)
  yield takeEvery(constants.ENTER_INPUT_AMOUNT, enterInputAmount)
}